export default [
  {
    path: '/connect',
    name: 'connectapp',
    component: () => import('@/views/connect/ConnectApp.vue'),
    meta: {},
  },
];
